
import state from './fileState.js'
import mutations from './fileMutations.js'
import actions from './fileAction.js'
import getters from './fileGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

